/*
 * 搜尋 Taipei 101 時，共有以下正規化方式
 * 1. NFD Normalization Form Canonical Decomposition：將含有重音之類的字元拆成兩個字元
 * 2. 將重音符號取代為空字串
 * 3. 將所有文字轉為小寫
 * 4. 只去除開頭空白：因為 Redis Sorted Set 的特性，若將結尾空白也去除的話，很有可能 keyword 與預期中的 candidate 差距過遠而無法搜尋到
 */

/** normalizeKeyword
 * @param {string} keyword 需正規化的字串
 * @returns {string}
 */
export const normalizeKeyword = keyword => {
  let normalizationKeyword = keyword
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  normalizationKeyword = normalizationKeyword.toLowerCase().trimStart();

  return normalizationKeyword;
};
